import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

const getCardImageService = (actionCallback, programId) => {
let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    console.log("plink",plink)
    const state = {
        createdBy: localStorage.getItem('accountId'),
        name: programId,
    }
    let token = "Token" + localStorage.getItem('token')
    let gid = getClientId();
    let traceId = getClientId();
    fetch(plink + s.get_cardImage, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            //  'Authorization': token,
            'clientId': gid,
            'clientSecret': getClientSecret(gid, programId),
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
            "Pragma-directive": "no-cache",
            "Cache-directive": "no-cache",
            "Cache-control": "no-cache",
            "Pragma": "no-cache",
            "Expires": 0,
        },

        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            }
            else if (res.status === 204) {
                let data = ""
                actionCallback(data, "emptyBody")
            }
            else if (res.status === 401) {

                //     localStorage.clear(
                //     this.props.history.push("/")
                let errorOut = "logout"
                actionCallback(errorOut)
            }
            else {
                // 
                actionCallback(res.headers.get('message'), "error")
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
            }
        })
}

export default getCardImageService;


// WEBPACK FOOTER //
// ./src/services/components/getcardimage.jsx